module.exports = __webpack_public_path__ + "img/13.3403cf02.jpg";